import Vue from 'vue';

const localeCountry = window.afdcStationsOptions.localeCountry || 'US';

export default function (e) {
  let errorMessage;

  if (e.response && e.response.data && e.response.data.errors) {
    const { errors } = e.response.data;

    if (errors.some((error) => error.includes("Couldn't find alternative fuel station"))) {
      errorMessage = Vue.$t('The station could not be found. Please try searching for another station.');
    }

    if (errors.some((error) => error.includes('could not be located'))) {
      errorMessage = Vue.$t('The location could not be found. Please try another location.');
    }

    if (errors.some((error) => error.includes('Unable to geocode address'))) {
      errorMessage = Vue.$t('The location could not be found. Please try another location.');
    }

    if (errors.some((error) => error.includes('Distance cannot exceed'))) {
      if (localeCountry === 'CA') {
        errorMessage = Vue.$t('Your search exceeds the maximum distance of 160 kilometers from the route. Please enter a shorter distance.');
      } else {
        errorMessage = Vue.$t('Your search exceeds the maximum distance of 100 miles from the route. Please enter a shorter distance.');
      }
    }

    if (errors.some((error) => error.includes('Radius cannot exceed'))) {
      if (localeCountry === 'CA') {
        errorMessage = Vue.$t('Your search exceeds the maximum radius of 804 kilometers from the location. Please enter a smaller radius.');
      } else {
        errorMessage = Vue.$t('Your search exceeds the maximum radius of 500 miles from the location. Please enter a smaller radius.');
      }
    }

    if (errors.some((error) => error.includes('Unable to calculate route'))) {
      errorMessage = Vue.$t('A driving route could not be found between your starting and ending locations.');
    }
  }

  // Handle unexpected errors and log them to rollbar.
  if (!errorMessage) {
    errorMessage = Vue.$t('An unexpected error occurred. Please try again or contact us for assistance.');

    let rollbarMessage;
    if (e.response && e.response.data && e.response.data.error && typeof e.response.data.error.message === 'string') {
      // API Umbrella errors (unauthorized API key, over rate limit, etc).
      rollbarMessage = e.response.data.error.message;
    } else if (e.response && e.response.data && e.response.data.errors && Array.isArray(e.response.data.errors)) {
      // Station API errors.
      rollbarMessage = e.response.data.errors.sort().join('; ');
    } else if (e.message) {
      // Generic exceptions.
      rollbarMessage = e.message;
    }

    // Unknown errors.
    if (!rollbarMessage) {
      rollbarMessage = 'Unexpected error';
    }

    // Include extra metadata from the exception object if it's an axios ajax
    // response object.
    const rollbarCustom = {};
    if (e.response) {
      rollbarCustom.responseStatus = e.response.status;
      rollbarCustom.responseStatusText = e.response.statusText;
      rollbarCustom.responseData = e.response.data;
      rollbarCustom.responseHeaders = e.response.headers;
      if (e.response.request) {
        rollbarCustom.responseReadyState = e.response.request.readyState;
        rollbarCustom.responseURL = e.response.request.responseURL;
        rollbarCustom.responseText = e.response.request.responseText;
      }
    }

    // Report the error to rollbar.
    Vue.$rollbar.error(rollbarMessage, e, rollbarCustom);
  }

  return errorMessage;
}
